export default __webpack_public_path__ + "static/media/IKetutNukayasa.5ba0b267.png";